import { UICircularProgress, UICircularProgressProps, UILinearProgress } from ".";

interface Props extends UICircularProgressProps {
  linear?: boolean;
}

export const UILoader = ({ linear, className, ...props }: Props) => {
  if (linear) {
    return <UILinearProgress color={(props.color as any) || "primary"} className={className} />;
  }
  return <UICircularProgress data-cy="circular-loader" color="primary" {...props} className={className} />;
};

export default UILoader;
